import services from "@/http";
import * as types from "./mutation-types";

export const ActionGetAll = async ({ dispatch }, payload) => {
  let data = await dispatch("ActionFind", payload);
  dispatch("ActionSetExtratores", data.data);
  dispatch("ActionSetPagination", data.meta);
};

export const ActionFind = async ({ commit }, search) => {
  commit(types.SET_LOADING, true);
  var extratores = {
    data: [],
    meta: {},
  };

  await services.extratores.get_all(search).then((res) => {
    extratores = res.data;
  });
  commit(types.SET_LOADING, false);
  return extratores;
};

export const ActionShow = async ({ dispatch, commit }, id) => {
  commit(types.SET_LOADING, true);
  await services.extratores.show({ id: id }).then((res) => {
    dispatch("ActionSetExtratores", res.data.extratores);
  });
  commit(types.SET_LOADING, false);
};

export const ActionSave = async ({ dispatch, commit }, payload) => {
  commit(types.SET_LOADING, true);

  if (payload.id) {
    await dispatch("ActionUpdate", payload);
  } else {
    await dispatch("ActionStore", payload);
  }

  commit(types.SET_LOADING, false);
};

export const ActionStore = async ({ commit }, payload) => {
  await services.extratores.store(payload).then((res) => {
    commit(types.SET_EXTRATORES, res.data.extratores);
  });
};

export const ActionUpdate = async ({ commit }, payload) => {
  await services.extratores
    .update({ id: payload.id }, payload)
    .then((res) => {
      commit(types.SET_EXTRATORES, res.data.extratores);
    });
};

export const ActionDelete = async ({ commit }, id) => {
  commit(types.SET_LOADING, true);
  await services.extratores.delete({ id: id }).then(() => {
    commit(types.SET_EXTRATORES, null);
  });
  commit(types.SET_LOADING, false);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionSetLoading = ({ commit }, loading) => {
  commit(types.SET_LOADING, loading);
};

export const ActionList = async ({ commit }, payload) => {
  commit(types.SET_LOADING, true);
  await services.extratores.get_all(payload).then(({ data }) => {
    commit(types.SET_EXTRATORESLIST, data.data.data);
    commit(types.SET_PAGINATION, data.data);
  });
  commit(types.SET_LOADING, false);
};